import React from 'react';
import { AuthSideNav } from '../../components/sideNav';
import { classNames } from '../../utils';
import Layout from './Layout';

type AuthLayoutProps = {
  stripPadding?: boolean;
  children?: React.ReactNode;
};

function AuthLayout({
  stripPadding = false,
  children,
}: AuthLayoutProps): JSX.Element {
  return (
    <Layout>
      <div className='flex flex-1 flex-row'>
        <AuthSideNav />
        <div
          className={classNames(
            'relative ml-12 flex-1 bg-gray-lightest',
            stripPadding ? '' : 'px-12 py-14',
          )}
        >
          {children}
        </div>
      </div>
    </Layout>
  );
}

export default AuthLayout;
